import axios from '@axios'

const route = 'dashboard'

export default {
  namespaced: true,
  state: {
    preferences: {},
  },
  getters: {
    getPreferences(state) {
      return state.preferences
    },
  },
  mutations: {
    setPreferences(state, preferences) {
      state.preferences = preferences
    },
  },
  actions: {
    getSaleWeek(context) {
      return axios.post(`${route}/sale_week`)
    },

    semiAnnualSale(context) {
      return axios.post(`${route}/semi_annual_sale`)
    },

    getSaleOverview() {
      return axios.post(`${route}/sale_overview`)
    },

    getSaleOverviewService() {
      return axios.post(`${route}/sale_overview_service`)
    },

    getRevenueExpenseReport() {
      return axios.post(`${route}/revenue_expense_report`)
    },

    getScheduleToday() {
      return axios.post(`${route}/schedule_today`)
    },

    // carrega os items do estoque baixo
    getLowStockItems() {
      return axios.post(`${route}/low_stock_items`)
    },

    getRevenueOverdueTotal() {
      return axios.post(`${route}/revenue_overdue_total`)
    },

    getExpenseOverdueTotal() {
      return axios.post(`${route}/expense_overdue_total`)
    },
    getStockTotal() {
      return axios.post(`${route}/stock_total`)
    },
    getCashComposition() {
      return axios.post(`${route}/cash_composition`)
    },
    getRevenueExpense8DaysReport() {
      return axios.post(`${route}/revenue_expense_8_days_report`)
    },
    fetchPreferences(context) {
      return axios.get(`${route}/preferences`).then(response => {
        context.commit('setPreferences', response.data)
        return response.data
      })
    },
    savePreferences(context, preferences) {
      return axios.post(`${route}/preferences`, { preferences })
    },
  },
}
